// FILE: /src/services/auth.js (FULLY UPDATED)

import axios from 'axios';
import axiosServices from "./axios";

export const loginApi = async (data) => {
  try {
    const response = await axiosServices.post(`/user/login/`, data);
    return { error: false, data: response?.data?.data };
  } catch (error) {
    return { error: true, data: error?.response?.data };
  }
};

/**
 * Checks if an email is already registered in the system.
 * This is a public route and does not use the auth interceptor.
 * @param {string} email The email address to check.
 * @returns {Promise<{exists: boolean}>}
 */
export const checkEmailExists = async (email) => {
    try {
        // Using a plain axios instance because this is a public endpoint
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_API}/user/check-email`, { email });
        return response.data; // e.g., { exists: false, message: '...' }
    } catch (error) {
        // If the API returns 409, it means the email exists.
        if (error.response && error.response.status === 409) {
            return { exists: true };
        }
        // For other errors, re-throw to be handled by the component.
        throw error;
    }
};